@switch (columnName) {
  @default {
    {{ element[columnName] ?? '---' }}
  }
  @case ('updateRunTimeCounterIcon__hidden') {
    <span class="vertical-center"><mat-icon>schedule</mat-icon></span>
  }
  @case ('dropdownForRunTimeChildren__hidden') {
    @if (element.hasChildren && !element.parentRuntimeId) {
      <span class="vertical-center">
        <mat-icon>expand_more</mat-icon>
      </span>
    }
  }
  @case ('averageDailyRunTime') {
    {{ element.averageDailyRunTime ?? '---' }}
  }
  @case ('status') {
    <div class="runtime-status-cell">
      <app-ui-pill [name]="element[columnName]"></app-ui-pill>
      @if (element.isPaused) {
        <app-department-paused-badge></app-department-paused-badge>
      }
    </div>
  }
  @case ('pausable') {
    <div class="pausable-cell">
      {{ (element.pausable ? 'yes' : 'no') | translate }}
    </div>
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions ?? []; track $index) {
      <app-text-overflow-label [text]="position.name"></app-text-overflow-label>
    }
    @for (positionGroup of element.responsibleForPositionGroups ?? []; track $index) {
      <app-text-overflow-label [text]="positionGroup.name"></app-text-overflow-label>
    }
    @for (role of element.responsibleForRoles ?? []; track $index) {
      <app-text-overflow-label [text]="role.name"></app-text-overflow-label>
    }
  }
}
